import {
  GratiRichTextContent as SharedGratiRichTextContent,
  DocContentType as SharedDocContentType,
  DOC_CONTENT_TYPES as SharedDocContentTypes,
  ALL_DOC_CONTENT_TYPES as SharedAllDocContentTypes
} from "shared/dist/types/GratiRichTextContent";

export type DocContentType = SharedDocContentType;
export const DOC_CONTENT_TYPES = SharedDocContentTypes;
export const ALL_DOC_CONTENT_TYPES = SharedAllDocContentTypes;

export default interface GratiRichTextContent extends SharedGratiRichTextContent {}